// Which product surfaces this host serves — GET /api/features, the SPA half of
// backend/app/features.py. One flag today: `cash` (CASH_ENABLED). Off = the
// play-money book + BMO DFS only: the cashier, deposit limits, responsible
// gaming and the verify wizard redirect home (middleware/cash.ts), the nav
// loses their leaves, the lobby its Cash tab, the footer its cash/RG cluster.
//
// Loaded ONCE per SSR render by layouts/default.vue (and by the cash middleware
// when it runs first): the answer rides the payload in useState, so hydration
// and every client-side navigation read the same value and never refetch. A
// failed read resolves to cash OFF — the fail-closed direction: a surface that
// hides when the api is unreachable is a surface that could not have worked.
export interface Features { cash: boolean }

export function useFeatures() {
  const features = useState<Features | null>('features', () => null)
  const api = useApi()

  async function load(): Promise<Features> {
    if (features.value) return features.value
    try {
      const f = await api.get<Features>('/features')
      features.value = { cash: f?.cash === true }
    } catch {
      features.value = { cash: false }
    }
    return features.value
  }

  const cashEnabled = computed(() => features.value?.cash === true)
  return { features, load, cashEnabled }
}
